import { ReactComponent as HepsiburadaLogo } from "~assets/images/e-commerce/hepsiburada.svg";
import { ReactComponent as IdeasoftLogo } from "~assets/images/e-commerce/ideasoft.svg";
import { ReactComponent as IkasLogo } from "~assets/images/e-commerce/ikas.svg";
import { ReactComponent as NavlungoLogo } from "~assets/images/e-commerce/navlungo.svg";
import { ReactComponent as ProjeLogo } from "~assets/images/e-commerce/proje.svg";
import { ReactComponent as ShopifyLogo } from "~assets/images/e-commerce/shopify.svg";
import { ReactComponent as TicimaxLogo } from "~assets/images/e-commerce/ticimax.svg";
import { ReactComponent as TrendyolLogo } from "~assets/images/e-commerce/trendyol.svg";
import { ReactComponent as TsoftLogo } from "~assets/images/e-commerce/tsoft.svg";
import ConstantHelper from "~helpers/ConstantHelper";

export const [eCommerceProject, eCommerceProjectOptions, eCommerceProjectMap] = ConstantHelper.typify({
  /** @type {"Trendyol"} */
  YT: "Trendyol",
  /** @type {"Ideasoft"} */
  PD: "Ideasoft",
  /** @type {"Proj-e"} */
  PP: "Proj-e",
  /** @type {"Ticimax"} */
  PT: "Ticimax",
  /** @type {"Shopify"} */
  PS: "Shopify",
  /** @type {"Ikas"} */
  PI: "Ikas",
  /** @type {"TSoft"} */
  PTS: "TSoft",
  /** @type {"Hepsiburada"} */
  YH: "Hepsiburada",
  /** @type {"Navlungo"} */
  NA: "Navlungo",

  // PE: "Email",
  // YE: "Etsy",
  // PW: "Woocommerce",
  // PN: "Next4Biz",
  // YA: "Amazon",
  // YN: "N11",
  // YG: "Gittigidiyor",
  // YP: "PTTAVM",
});
// yt,pd,pp,pt,ps,pi

export const eCommerceDefinitionList = [
  {
    //Trendyol
    key: eCommerceProject.YT,
    name: eCommerceProjectMap[eCommerceProject.YT],
    configParams: [
      { label: window.t("constants.eCommerce.trendyol.sellerId"), key: "seller_id", required: true, fullWidth: true },
      { label: window.t("constants.eCommerce.trendyol.apiKey"), key: "username", required: true },
      { label: window.t("constants.eCommerce.trendyol.apiSecret"), key: "password", required: true },
    ],
    logo: TrendyolLogo,
    logoStyles: {},
  },
  {
    //IdeaSoft
    key: eCommerceProject.PD,
    name: eCommerceProjectMap[eCommerceProject.PD],
    configParams: [
      { label: "Base URL", key: "base_url", required: true, type: "url", fullWidth: true },
      { label: "Client ID", key: "client_id", required: true },
      { label: "Client Secret", key: "client_secret", required: true },
      { label: "Access Token", key: "access_token", required: true },
      { label: "Refresh Token", key: "refresh_token", required: true },
    ],
    logo: IdeasoftLogo,
  },
  {
    //Proj-e
    key: eCommerceProject.PP,
    name: eCommerceProjectMap[eCommerceProject.PP],
    configParams: [
      { label: "Base URL", key: "base_url", required: true, type: "url", fullWidth: true },
      { label: window.t("common.username"), key: "username", required: true },
      { label: window.t("common.password"), key: "password", required: true },
    ],
    logo: ProjeLogo,
  },
  {
    //Ticimax
    key: eCommerceProject.PT,
    name: eCommerceProjectMap[eCommerceProject.PT],
    configParams: [
      { label: "Base URL", key: "base_url", required: true, type: "url", fullWidth: true },
      {
        label: window.t("constants.eCommerce.ticimax.memberCode"),
        key: "member_code",
        required: true,
        fullWidth: true,
      },
    ],
    logo: TicimaxLogo,
  },
  {
    //Shopify
    key: eCommerceProject.PS,
    name: eCommerceProjectMap[eCommerceProject.PS],
    configParams: [
      { label: "Domain", key: "domain", required: true, type: "domain", fullWidth: true },
      { label: "Access Token", key: "access_token", required: true, fullWidth: true },
    ],
    logo: ShopifyLogo,
  },
  {
    //Ikas
    key: eCommerceProject.PI,
    name: eCommerceProjectMap[eCommerceProject.PI],
    configParams: [
      { label: "Base URL", key: "base_url", required: true, type: "url", fullWidth: true },
      { label: "Client ID", key: "client_id", required: true, fullWidth: true },
      { label: "Client Secret", key: "client_secret", required: true, fullWidth: true },
      {
        label: window.t("constants.eCommerce.ikas.storeImageId"),
        key: "store_image_id",
        required: true,
        fullWidth: true,
      },
    ],
    logo: IkasLogo,
  },
  {
    //TSoft
    key: eCommerceProject.PTS,
    name: eCommerceProjectMap[eCommerceProject.PTS],
    configParams: [
      { label: "Base URL", key: "base_url", required: true, type: "url", fullWidth: true },
      { label: window.t("common.username"), key: "user_name", required: true },
      { label: window.t("common.password"), key: "password", required: true },
    ],
    logo: TsoftLogo,
  },
  {
    //Hepsiburada
    key: eCommerceProject.YH,
    name: eCommerceProjectMap[eCommerceProject.YH],
    configParams: [
      { label: window.t("constants.eCommerce.hepsiburada.username"), key: "username", required: true },
      { label: window.t("constants.eCommerce.hepsiburada.password"), key: "password", required: true },
      { label: window.t("constants.eCommerce.hepsiburada.userAgent"), key: "user_agent", required: true },
    ],
    logo: HepsiburadaLogo,
  },
  {
    //Navlungo
    key: eCommerceProject.NA,
    name: eCommerceProjectMap[eCommerceProject.NA],
    configParams: [
      { label: window.t("constants.eCommerce.navlungo.username"), key: "username", required: true },
      { label: window.t("constants.eCommerce.navlungo.password"), key: "password", required: true },
    ],
    logo: NavlungoLogo,
  },
];

export const eCommerceDataSourceType = {
  PLATFORM_MESSAGE: "PM",
  PRODUCT: "P",
  PRODUCT_REVIEW: "PR",
  CUSTOMER: "C",
  WEBHOOK: "W",
  CUSTOM: "CU",
};

export const eCommerceDataSourceTypeList = [
  {
    key: eCommerceDataSourceType.PLATFORM_MESSAGE,
    name: "Platform Message",
  },
  {
    key: eCommerceDataSourceType.PRODUCT,
    name: "Product",
  },
  {
    key: eCommerceDataSourceType.PRODUCT_REVIEW,
    name: "Product Review",
  },
  {
    key: eCommerceDataSourceType.CUSTOMER,
    name: "Customer",
  },
  {
    key: eCommerceDataSourceType.WEBHOOK,
    name: "Webhook",
  },
  {
    key: eCommerceDataSourceType.CUSTOM,
    name: "Custom",
  },
];
export const eCommerceDataSourceTypeMap = {
  [eCommerceDataSourceType.PLATFORM_MESSAGE]: "Platform Message",
  [eCommerceDataSourceType.PRODUCT]: "Product",
  [eCommerceDataSourceType.PRODUCT_REVIEW]: "Product Review",
  [eCommerceDataSourceType.CUSTOMER]: "Customer",
  [eCommerceDataSourceType.WEBHOOK]: "Webhook",
  [eCommerceDataSourceType.CUSTOM]: "Custom",
};

export const eCommerceDataSourceStatusType = {
  FRESH: "Fresh",
  PROCESSING: "Processing",
  PROCESSED: "Processed",
  ERROR: "Error",
};

export const eCommerceDataSourceStatusTypeList = [
  {
    key: eCommerceDataSourceStatusType.FRESH,
    name: "Fresh",
  },
  {
    key: eCommerceDataSourceStatusType.PROCESSING,
    name: "Processing",
  },
  {
    key: eCommerceDataSourceStatusType.PROCESSED,
    name: "Processed",
  },
  {
    key: eCommerceDataSourceStatusType.ERROR,
    name: "Error",
  },
];
export const eCommerceDataSourceStatusTypeMap = {
  [eCommerceDataSourceStatusType.FRESH]: "Fresh",
  [eCommerceDataSourceStatusType.PROCESSING]: "Processing",
  [eCommerceDataSourceStatusType.PROCESSED]: "Processed",
  [eCommerceDataSourceStatusType.ERROR]: "Error",
};
